import {
    IdogcamAccessType,
    IdogcamCamera,
    IdogcamCameraChanges,
    IdogcamCamerasPage,
    IdogcamIntegration,
    IdogcamLocation,
    IdogcamRoom,
    IdogcamViewerLaunch
} from '../model/IdogcamModel';
import {
    IdogcamCameraChangesDto,
    IdogcamCameraDto,
    IdogcamCamerasPageDto,
    IdogcamIntegrationDto,
    IdogcamLocationDto,
    IdogcamRoomDto,
    IdogcamViewerLaunchDto
} from './IdogcamDtos';

const convertAccessType = (accessType: string | null): IdogcamAccessType | null =>
    accessType === 'public' || accessType === 'private' ? accessType : null;

export const convertIntegration = (dto: IdogcamIntegrationDto): IdogcamIntegration => ({
    configured: dto.configured,
    kennelId: dto.kennel_id,
    erpcode: dto.erpcode,
    platformConfigured: dto.platform_configured,
    camerasCount: dto.cameras_count
});

export const convertCamera = (dto: IdogcamCameraDto): IdogcamCamera => ({
    id: dto.id,
    uuid: dto.uuid,
    externalId: dto.external_id,
    name: dto.name,
    active: dto.active,
    accessType: convertAccessType(dto.access_type),
    addressId: dto.address_id,
    addressName: dto.address_name,
    roomId: dto.room_id,
    roomName: dto.room_name,
    roomUnitId: dto.room_unit_id,
    roomUnitName: dto.room_unit_name
});

export const convertLocation = (dto: IdogcamLocationDto): IdogcamLocation => ({
    id: dto.id,
    name: dto.name,
    main: dto.main
});

export const convertRoom = (dto: IdogcamRoomDto): IdogcamRoom => ({
    id: dto.id,
    name: dto.name,
    units: (dto.room_units ?? []).map(unit => ({ id: unit.id, name: unit.name, active: unit.active }))
});

export const convertCamerasPage = (dto: IdogcamCamerasPageDto): IdogcamCamerasPage => ({
    configured: dto.configured,
    locations: (dto.locations ?? []).map(convertLocation),
    cameras: dto.cameras.map(convertCamera),
    page: dto.page,
    size: dto.size,
    totalPages: dto.total_pages,
    totalRecords: dto.total_records
});

export const convertCameraChangesToDto = (changes: IdogcamCameraChanges): IdogcamCameraChangesDto => ({
    active: changes.active,
    access_type: changes.accessType,
    address_id: changes.addressId,
    // Public cameras are mapped by location only; the backend clears room/unit too.
    room_id: changes.accessType === 'private' ? changes.roomId : null,
    room_unit_id: changes.accessType === 'private' ? changes.roomUnitId : null
});

export const convertViewerLaunch = (dto: IdogcamViewerLaunchDto): IdogcamViewerLaunch => ({
    viewerUrl: dto.viewer_url,
    method: dto.method,
    authParam: dto.auth_param,
    auth: dto.auth
});
